import React, { useState } from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DrawerSubmenu from "./DrawerSubmenu";
import { CategoryContainer, ListItemStyled } from "./MobileDrawer.styles";
import PropTypes from "prop-types";
import Button from '../button/button';
import commonUtil from "../../../utils/commonUtil";


const DrawerCategory = ({ category, index, actions, closeDrawer }) => {
  const [collapseState, setCollapseState] = useState({});

  const handleCollapseToggle = (key) => () => {
    setCollapseState((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const key = `category${index + 1}`;

  const showAccordionExpandIcon = category?.submenus?.length > 1;

  // Function to handle menu click if it has submenu items then expand/collapse else redirect to submenu item link
  const handleClick = (item) => {
    if (item?.submenus && item?.submenus.length > 0) {
      handleCollapseToggle(key)(); // Trigger collapse only if it has children
    } else {
      commonUtil.handleRedirection(item?.acf?.url);
      closeDrawer();
    }
  };

  return (
    !category?.acf?.isbutton ? (<CategoryContainer>
      <ListItemStyled>
        <ListItemButton
          sx={{ color: "primary.main", flexGrow: 1, py: 0 }}
          onClick={() => handleClick(category)}
        >
          <ListItemText
            primary={category?.name}
            primaryTypographyProps={{
              fontFamily: "body.fontFamily.secondary",
              fontWeight: "700",
              fontSize: "18px",
            }}
          />
        </ListItemButton>
        {showAccordionExpandIcon && (
          <IconButton
            aria-label={`expand ${category?.name}`}
            onClick={() => handleClick(category)} // Correct function invocation
            sx={{ color: "primary.main" }}
          >
            {collapseState[key] ? (
              <ExpandLess sx={{ width: "20px", height: "28px" }} />
            ) : (
              <ExpandMore sx={{ width: "20px", height: "28px" }} />
            )}
          </IconButton>
        )}
      </ListItemStyled>
      <Collapse in={collapseState[key]} timeout="auto" unmountOnExit>
        <List component="div" disablePadding sx={{ color: "#000000" }}>
          {category?.submenus.map((submenu, subIndex) => ( // Display accordion for submenu items.
            <DrawerSubmenu
              key={`submenu${subIndex}`}
              submenu={submenu}
              parentKey={key}
              isTopLevel={true}
              isLastItem={subIndex === category?.submenus.length - 1}
              handleClick={handleClick}
            />
          ))}
        </List>
      </Collapse>
    </CategoryContainer>) : (<Button
      color={category?.acf?.background_color === "text" ? "#000000" : category?.acf?.background_color}
      size={category?.acf?.size}
      sx={{
        marginTop: category?.acf?.background_color === "text" ? "10px" : "0px"
      }}
      onClick={() => handleClick(category)}
      variant={category?.acf?.button_variant}
    >
      <div dangerouslySetInnerHTML={{ __html: category?.acf?.title }} />
    </Button>) // Display the submenu item directly 
  );
};
export default DrawerCategory;

DrawerCategory.propTypes = {
  category: PropTypes.shape({
    name: PropTypes.string,
    link: PropTypes.string,
    submenus: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        link: PropTypes.string,
        submenus: PropTypes.array,
      }),
    ),
  }),
  index: PropTypes.number,
  actions: PropTypes.shape({
    router: PropTypes.shape({
      set: PropTypes.func,
    }),
  }),
  closeDrawer: PropTypes.func,
};
